import { Navigate, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import { ORDER_QUERY } from '../../queries';
import LoadingOverlay from '../LoadingOverlay';

export default function ExistingOrderRedirect({ createStateFn }) {
  const { orderId } = useParams();

  const { loading, error, data } = useQuery(ORDER_QUERY, {
    variables: { orderId },
  });

  const order = data?.order;

  if (loading) {
    return <LoadingOverlay message="Retrieving your order..." />;
  }

  if (error) {
    return <Navigate to="/dashboard/mywork/orders" />;
  }

  return <Navigate to="../" state={createStateFn(order)} />;
}
